import React from 'react';
import { string } from 'prop-types';

import { useConfiguration } from '../../../../context/configurationContext';

import { FormattedMessage, injectIntl, useIntl } from '../../../../util/reactIntl';
import { lazyLoadWithDimensions } from '../../../../util/uiHelpers';
import { formatMoney, formatMoneyRoundWithoutDecimals } from '../../../../util/currency';
import { ensureListing } from '../../../../util/data';
import { types as sdkTypes } from '../../../../util/sdkLoader';
const { Money } = sdkTypes;
import { AspectRatioWrapper, NamedLink, ResponsiveImage } from '../../../../components';

import css from './ListingCard.module.css';
import { createSlug } from '../../../../util/urlHelpers';

// Utility function to get the first image
const getFirstImage = (currentListing, listingType) => {
  let orderedImages = [];

  const productImagesOrder = currentListing.attributes?.publicData?.productImagesOrder || [];
  orderedImages = [...currentListing.images].sort((a, b) => {
    const aIndex = productImagesOrder.indexOf(a.id?.uuid);
    const bIndex = productImagesOrder.indexOf(b.id?.uuid);
    if (aIndex === -1 && bIndex === -1) return 0;
    if (aIndex === -1) return 1;
    if (bIndex === -1) return -1;
    return aIndex - bIndex;
  });

  return orderedImages.length > 0 ? orderedImages[0] : null;
};

const LazyImage = lazyLoadWithDimensions(ResponsiveImage, { loadAfterInitialRendering: 3000 });

export const ListingCardComponent = props => {
  const config = useConfiguration();
  const intl = useIntl();

  const { className, rootClassName, listing, renderSizes, showPriceInfo, brandName } = props;
  const currentListing = ensureListing(listing);
  const id = currentListing.id.uuid;
  const { title = '', publicData } = currentListing.attributes;
  const { finalDisplayRate, listingType, unitType, discountedPrice, discount } = publicData;
  const slug = createSlug(title);

  const firstImage = getFirstImage(currentListing, listingType) || {};

  const {
    aspectWidth = 3,
    aspectHeight = 4,
    variantPrefix = 'product-card',
  } = config.layout.productImage;

  const variants = firstImage
    ? Object.keys(firstImage?.attributes?.variants).filter(k => k.startsWith(variantPrefix))
    : [];

  const price =
    finalDisplayRate &&
    finalDisplayRate?.amount &&
    new Money(finalDisplayRate.amount, config.currency);
  const formattedFinalDisplayRate = price ? formatMoneyRoundWithoutDecimals(intl, price) : null;

  const discountedPriceMaybe = discountedPrice
    ? formatMoneyRoundWithoutDecimals(
        intl,
        new Money(discountedPrice.amount, discountedPrice.currency)
      )
    : null;

  const formattedPrice = currentListing?.attributes?.price
    ? formatMoneyRoundWithoutDecimals(intl, currentListing.attributes.price)
    : null;

  return (
    // <NamedLink name={"ProductListingPage"} params={{ id, slug }}>
    <div className={css.root}>
      <AspectRatioWrapper
        className={css.aspectRatioWrapper}
        width={aspectWidth}
        height={aspectHeight}
      >
        <LazyImage
          rootClassName={css.rootForImage}
          alt={title}
          image={firstImage}
          variants={variants}
          sizes={renderSizes}
        />
      </AspectRatioWrapper>
      {/*<div className={css.info}>*/}
      {/*  {formattedFinalDisplayRate &&*/}
      {/*    <FormattedMessage id="ListingCard.priceToDisplay" values={{ price: formattedFinalDisplayRate }} />*/}
      {/*  }*/}
      {/*</div>*/}

      {/*{showPriceInfo &&*/}
      {/*  <div className='col'>*/}
      {/*    <p className={css.brandTitle}>{brandName}</p>*/}
      {/*    <p className={css.title}>{title}</p>*/}
      {/*    <div className={css.priceContainer}>*/}
      {/*      {discountedPriceMaybe ?*/}
      {/*        <>*/}
      {/*          <span className={css.priceDiscounted}>{formattedPrice}</span>*/}
      {/*          <span className={css.discount}>{discount + '%'}</span>*/}
      {/*          <span className={css.priceBeforeDiscount}>{discountedPriceMaybe}</span>*/}
      {/*        </>*/}
      {/*        :*/}
      {/*        <>*/}
      {/*          <span className={css.price}>{formattedPrice}</span>*/}
      {/*        </>*/}
      {/*      }*/}
      {/*    </div>*/}
      {/*  </div>*/}
      {/*}*/}
    </div>
    // </NamedLink >
  );
};

ListingCardComponent.defaultProps = {
  className: null,
  rootClassName: null,
  renderSizes: null,
};

ListingCardComponent.propTypes = {
  className: string,
  rootClassName: string,
  // Responsive image sizes hint
  renderSizes: string,
};

export default injectIntl(ListingCardComponent);
